import { ReactNode } from 'react'

import { DashboardModule, Grid } from '@domain-group/suit-theme'

import type { CustomFieldsGroup } from '@hooks/useEntityTypeCustomFields'
import type { UseEntityCustomFieldsFormPayload } from '@hooks/useEntityCustomFieldsForm'

import Field from '../Field'

interface FieldGroupProps {
  children: ReactNode,
  customFieldGroup: CustomFieldsGroup,
  customFieldsForm: UseEntityCustomFieldsFormPayload,
}

const FieldGroup = (props: FieldGroupProps) => {
  const {
    children,
    customFieldGroup,
    customFieldGroup: { items, label },
    customFieldsForm,
  } = props

  if (typeof children === 'function'){
    // @ts-expect-error TS2349
    return children({
      customFieldGroup,
    })
  }

  return (
    <DashboardModule title={label}>
      <Grid
        // @ts-expect-error TS2322
        gridGap="medium"
        gridTemplateColumns={['repeat(2, 1fr)', 'repeat(4, 1fr)']}
        margin="large"
        marginBottom="medium"
        width={['auto', '100%']}
      >
        {items.map(customField => (
          <Field customField={customField} customFieldsForm={customFieldsForm} key={customField.id} />
        ))}
      </Grid>
    </DashboardModule>
  )
}

export default FieldGroup
